import React from "react";
import { Link } from "react-router-dom";
import { brandImages } from "../config/images";


/**
 * Footer
 * Props:
 *  - brand: { name, tagline }
 *  - footer: { copyright, tagline }
 *  - contact: { address, email, phone, social }
 */
function Footer({ brand, footer, contact }) {
  return (
    <footer className="bg-navy text-white pt-5 pb-4 mt-5">
      <div className="container">
        <div className="row gy-4">
          <div className="col-md-4">
            
            <div className="mb-3">
              <img
                src={brandImages.logo}
                alt={`${brand.name} logo`}
                width="150"
                height="150"
                className="rounded-circle"
              />
            </div>
            <h5 className="fw-bold mb-2">{brand.name}</h5>
            <p className="small mb-1">{brand.fullName}</p>
            <p className="small text-saffron">{footer.tagline}</p>
          </div>

          <div className="col-md-4">
            <h6 className="fw-bold mb-3">Quick Links</h6>
            <ul className="list-unstyled small">
              <li className="mb-2"><Link to="/">Home</Link></li>
              <li className="mb-2"><Link to="/about">About Us</Link></li>
              {/* <li className="mb-2"><Link to="/members">Committee</Link></li>
              <li className="mb-2"><Link to="/events">Events</Link></li>
              <li className="mb-2"><Link to="/gallery">Gallery</Link></li> */}
              <li className="mb-2"><Link to="/contact">Contact</Link></li>
            </ul>
          </div>

          <div className="col-md-4">
            <h6 className="fw-bold mb-3">Contact</h6>
            <ul className="list-unstyled small">
              <li className="mb-2"><i className="bi bi-geo-alt-fill me-2"></i>{contact.address}</li>
              <li className="mb-2"><i className="bi bi-envelope-fill me-2"></i>{contact.email}</li>
              <li className="mb-2"><i className="bi bi-telephone-fill me-2"></i>{contact.phone}</li>
            </ul>
            <div className="d-flex gap-3 mt-3 fs-5">
              {contact.social?.facebook && (
                <a href={contact.social.facebook} target="_blank" rel="noreferrer" aria-label="Facebook">
                  <i className="bi bi-facebook"></i>
                </a>
              )}
              {contact.social?.instagram && (
                <a href={contact.social.instagram} target="_blank" rel="noreferrer" aria-label="Instagram">
                  <i className="bi bi-instagram"></i>
                </a>
              )}
              {contact.social?.linkedin && (
                <a href={contact.social.linkedin} target="_blank" rel="noreferrer" aria-label="LinkedIn">
                  <i className="bi bi-linkedin"></i>
                </a>
              )}
            </div>
          </div>
        </div>

        <hr className="border-secondary my-4" />
        <p className="small text-center mb-0" style={{ color: "rgba(255,255,255,0.6)" }}>
          {footer.copyright}
        </p>
      </div>
    </footer>
  );
}

export default Footer;
